import { ComponentProps } from 'react';
import { WrappedFieldProps } from 'redux-form';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import FormError from 'dashboard/components/FormControls/FormError';
import MultiSelect from 'dashboard/components-lib/MultiSelect';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';

type MultiSelectProps<T> = ComponentProps<typeof MultiSelect<T>>;

export interface MultiSelectFieldProps extends MultiSelectProps<string> {
  autoFocus?: boolean;
  id?: string;
  label?: string;
  className?: string;
  placeholder?: string;
}

const MultiSelectField = (props: WrappedFieldProps & MultiSelectFieldProps) => {
  const {
    className,
    id,
    input,
    meta: { error, submitFailed, touched },
    autoFocus,
    label,
    placeholder,
    ...passthroughProps
  } = props;

  const hasError = !!(error && (submitFailed || touched));

  return (
    <FormGroup className={className}>
      {label && <FormControlLabel htmlFor={id}>{label}</FormControlLabel>}
      <MultiSelect {...input} {...passthroughProps} />
      {hasError && <FormError>{error}</FormError>}
    </FormGroup>
  );
};

export default MultiSelectField;
